// EsdevenimentsCarousel.tsx
"use client";

import Image from "next/image";
import { Box, Typography, Grid, IconButton } from "@mui/material";
import { pxToVw } from "@/utils/pxToVw";
import { MOBILE_BASE } from "@/theme/theme";

import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperType } from "swiper";
import { Navigation, A11y } from "swiper/modules";
import { useText } from "@/context/TextContext";

// Si no lo tienes ya en global.css / layout.tsx, importa los estilos de Swiper:
// import "swiper/css";
// import "swiper/css/navigation";

type EventItem = {
  id: string;
  num?: string;
  title: string;
  subtitle?: string;
  image: string;
  width: number; // ancho de la imagen base (para Next/Image)
  height: number; // alto de la imagen base (para Next/Image)
};

export default function EsdevenimentsCarousel() {
  const swiperRef = useRef<SwiperType | null>(null);

  const EVENTS: EventItem[] = [
    {
      id: "e1",
      //num: "01",
      title: "Casa Gay",
      //subtitle: "Tipologia de projecte",
      image: useText("lloguer.image1"),
      width: 344,
      height: 412,
    },
    {
      id: "e2",
      //num: "02",
      title: "Casa Gay",
      //subtitle: "Tipologia de projecte",
      image: useText("lloguer.image2"),
      width: 344,
      height: 412,
    },
    {
      id: "e3",
      //num: "03",
      title: "Casa Gay",
      //subtitle: "Tipologia de projecte",
      image: useText("lloguer.image3"),
      width: 344,
      height: 412,
    },
    {
      id: "e4",
      //num: "04",
      title: "Casa Gay",
      //subtitle: "Tipologia de projecte",
      image: useText("lloguer.image4"),
      width: 344,
      height: 412,
    },
  ];

  return (
    <Grid
      container
      size={12}
      mt={{ xs: pxToVw(30, MOBILE_BASE), md: pxToVw(30) }}
      mb={{ xs: pxToVw(80, MOBILE_BASE), md: pxToVw(160) }}
    >
      {/* Swiper (misma config de breakpoints que en ProductesCarousel) */}
      <Swiper
        modules={[Navigation, A11y]}
        onSwiper={(s) => (swiperRef.current = s)}
        slidesPerView={4}
        spaceBetween={8}
        speed={500}
        breakpoints={{
          0: { slidesPerView: 1.2, spaceBetween: 8 },
          600: { slidesPerView: 2, spaceBetween: 8 },
          900: { slidesPerView: 4, spaceBetween: 8 },
          1200: { slidesPerView: 4, spaceBetween: 8 },
        }}
        loop
        style={{ width: "100%" }}
      >
        {EVENTS.map((ev) => (
          <SwiperSlide key={ev.id}>
            {/* Imagen */}
            <Box
              sx={{ width: "100%", position: "relative" }}
              mb={{ xs: pxToVw(8, MOBILE_BASE), md: pxToVw(0) }}
            >
              <Image
                alt={ev.title}
                src={ev.image}
                width={ev.width}
                height={ev.height}
                style={{
                  width: "100%",
                  height: "fit-content",
                  transition: "none",
                }}
                loading="eager"
                priority={false}
                placeholder={undefined}
              />
            </Box>

            {/* Tipografía debajo de la imagen (igual que en EsdevenimentsSection) */}
            {ev.num && (
              <Box display="flex" flexDirection="row">
                <Grid container size={{ xs: 3, md: 4 }}>
                  <Typography variant="body5" color="marron">
                    {ev.num}
                  </Typography>
                </Grid>
                <Grid container size={{ xs: 8, md: 8 }}>
                  <Typography variant="body5" color="marron">
                    {ev.title} <br />
                    {ev.subtitle}
                  </Typography>
                </Grid>
              </Box>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </Grid>
  );
}
